import { Container, Grid } from "@material-ui/core";
import MaterialTable, { Column, Action } from "material-table";
import React, { useEffect, useState } from "react";
import Header from "./blades/Header";

import { Auth, DataStore } from "aws-amplify";
import { navigate } from "gatsby";
import AtlasPanel from "../atlas/blades/AtlasPanel";
import { DataPortalService } from "../api/DataPortalService";
import { Dataset, Project } from "../api/models";

const PortalProjects: React.FC<any> = ({ theme, props }) => {
  const [projects, setProjects] = useState<Array<any>>([]);
  const [columns, setColumns] = useState<Column<{}>[]>([
    { title: "Name", field: "name" },
  ]);
  const [actions, setActions] = useState<Action<{}>[]>([
    {
      icon: "arrow_forward",
      tooltip: "View Project",
      onClick: (event, rowData) => navigate(`/portal/project/${rowData.id}`),
    },
  ]);

  useEffect(() => {
    DataStore.query(Project).then(setProjects);
  }, []);

  return (
    <Container fixed style={{ paddingBottom: "60px" }}>
      <Header />
      <Grid container spacing={4} alignItems="stretch">
        <Grid item xs={12}>
          <AtlasPanel xs={12} title="Welcome">
            <div className="portalCopy">
              Welcome to the Data Core Portal (DCP). Here you will find data,
              tools, and resources to conduct research, develop web and mobile
              applications, design data visualizations, and more.
            </div>
          </AtlasPanel>
        </Grid>
        <Grid item xs={12}>
          <MaterialTable
            style={{ width: "100%" }}
            title={props.title}
            options={{
              showTitle: true,
              grouping: false,
              actionsColumnIndex: -1,
              // filtering: true,
              exportButton: true,
              // columnsButton: true,
              exportAllData: true,
              paging: false,
              headerStyle: {
                fontSize: "12px",
                fontWeight: "bold",
                padding: "3px 10px",
                whiteSpace: "nowrap",
                textTransform: "capitalize",
                zIndex: 0,
              },
              rowStyle: {
                fontSize: "13px",
              },
            }}
            actions={actions}
            columns={columns}
            data={projects}
          />
        </Grid>
      </Grid>
    </Container>
  );
};

export default PortalProjects;
